export default __webpack_public_path__ + "static/media/001-carbon dioxide.855bb726.svg";